export default __webpack_public_path__ + "static/media/city.55c36d3d.jpg";